import {Disclosure} from '@headlessui/react'
import { useRouter } from 'next/router';

export default function ProductDisclosure({faq}: {faq: any}) {
  const {locale } = useRouter();
  return (
    <div className="w-full">
      <div className="w-full">
        <Disclosure>
          {({open}) => (
            <>
              <Disclosure.Button className={`${locale === 'ar' ? 'flex' : 'flex flex-row-reverse'} w-full items-center lg:items-start justify-between rounded-lg p-4 text-left text-sm font-medium border-b-[1px] border-[##E6E9ED] lg:border-none`}>
                <span className="text-lg font-semibold text-primary text-start" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
                  {faq.heading}
                </span>

                <svg
                  className={`${
                    open ? '' : 'rotate-180 transform'
                  } h-4 w-4 text-primary-500`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 16 8"
                  strokeWidth="1.5"
                  stroke="currentColor">
                    <path d="M0.997099 7.94727C1.26223 7.94703 1.51641 7.84152 1.70377 7.65393L6.81843 2.53927C6.9732 2.38445 7.15695 2.26165 7.35919 2.17786C7.56143 2.09408 7.77819 2.05096 7.9971 2.05096C8.21601 2.05096 8.43277 2.09408 8.63501 2.17786C8.83724 2.26165 9.021 2.38445 9.17577 2.53927L14.2871 7.64727C14.4757 7.82942 14.7283 7.93022 14.9905 7.92794C15.2527 7.92566 15.5035 7.82049 15.6889 7.63508C15.8743 7.44968 15.9795 7.19886 15.9818 6.93667C15.9841 6.67447 15.8833 6.42187 15.7011 6.23327L10.5938 1.12527C9.90559 0.438442 8.97304 0.0527032 8.00077 0.0527033C7.02849 0.0527033 6.09594 0.438442 5.40777 1.12527L0.293099 6.23993C0.153355 6.37959 0.0581073 6.5575 0.0193786 6.75123C-0.019352 6.94497 0.000171626 7.14583 0.0754833 7.32847C0.150796 7.51112 0.278522 7.66737 0.442545 7.77749C0.606567 7.88762 0.799536 7.9467 0.997099 7.94727Z" fill="#00214D"/>
                </svg>
              </Disclosure.Button>
              <Disclosure.Panel
                className={`text-text-color leading-[2rem] px-4 py-6 text-[15px]`}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
                dangerouslySetInnerHTML={{
                  __html: faq.description
                    .replace(/\n/g, '<br/>')          // convert line breaks
                    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // convert **bold**
                }}
              />
            </>
          )}
        </Disclosure>
      </div>
    </div>
  )
}
